<template>
  <div>
    <div class="boss-calendar-month">
      <!--年月ヘッダー-->
      <div class="boss-calendar-month-head">
        <p
          class="boss-calendar-month-head-title"
          data-test="calendar-month-head-title"
        >
          {{ targetYear }}/{{ targetMonth }}
        </p>
      </div>
      <!--曜日ヘッダー-->
      <div class="boss-calendar-month-week">
        <template v-for="(weekDay, i) in weekDays">
          <interview-candidate-date-calendar-date
            :key="i"
            :can-edit="false"
            layout-type="week"
            :is-candidate="false"
            :display-text="weekDay"
            @changeNgWeek="changeNgWeek(i)"
          />
        </template>
      </div>
      <!--日付のループ表示-->
      <template v-for="(week, i) in weeks">
        <div
          :key="i"
          class="boss-calendar-month-week"
        >
          <template v-for="(date, j) in week">
            <interview-candidate-date-calendar-date
              :key="`${i}-${j}`"
              :can-edit="date.canEdit"
              :layout-type="date.layoutType"
              :is-candidate="date.isCandidate"
              :display-text="date.dateValue"
              @changeNgDate="changeNgDate"
            />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InterviewCandidateDateCalendarDate from '@/components/atoms/InterviewCandidateDateCalendarDate'
import dayjs from 'dayjs'
import _ from 'lodash'

export default {
  components: {
    InterviewCandidateDateCalendarDate
  },
  props: {
    targetYear: {
      type: Number,
      required: true
    },
    targetMonth: {
      type: Number,
      required: true
    },
    schedule: {
      type: Object,
      required: true
    },
    candidates: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      // 月曜切替: isChangedDayOfWeeks[0], 火曜切替: isChangedDayOfWeeks[1],  ..., 日曜切替: isChangedDayOfWeeks[6],
      isChangedDayOfWeeks: [...Array(7)].map(_ => false)
    }
  },
  computed: {
    weekDays: () => ['月', '火', '水', '木', '金', '土', '日'],
    // カレンダー作成対象月
    targetYearMonth () {
      return dayjs([this.targetYear, this.targetMonth - 1])
    },
    // 設定可能開始日
    settingStartDate () {
      return dayjs().startOf('date').add(this.schedule.startDay, 'days')
    },
    // 条件に応じてプロパティをセットし、最後に１週間ごとのchunkにする
    weeks () {
      const preBlanks = this.createBlanks(this.targetYearMonth.startOf('month').isoWeekday() - 1)
      const afterBlanks = this.createBlanks(7 - this.targetYearMonth.endOf('month').isoWeekday())

      return _.chunk(preBlanks.concat([...Array(this.targetYearMonth.daysInMonth())].map((_, i) => {
        const date = dayjs([
          this.targetYearMonth.get('year'),
          this.targetYearMonth.get('month'),
          i + 1
        ])
        return {
          canEdit: date.isSameOrAfter(this.settingStartDate),
          layoutType: this.getBackgroundColor(date),
          isCandidate: this.candidates.some(candidate => candidate.isSame(date)),
          dateValue: date.date().toString()
        }
      })).concat(afterBlanks), 7)
    }
  },
  methods: {
    getBackgroundColor (targetDate) {
      if (targetDate.isBefore(this.settingStartDate)) {
        return 'pass'
      } else if (this.schedule.ngDates.some(ngDate => dayjs(ngDate).isSame(targetDate))) {
        return 'ng'
      } else {
        return ''
      }
    },
    // 月の初日と最終日のそれぞれの曜日によって必要な数分空白日程を作成する
    createBlanks (arraySize) {
      return [...Array(arraySize)].map(() => {
        return {
          canEdit: false,
          layoutType: this.targetYearMonth <= dayjs() ? 'pass' : '',
          isCandidate: false,
          dateValue: ''
        }
      })
    },
    // 子コンポーネントからemitされるメソッド. 背景色がng色かどうか選択対象日付を親に渡す
    changeNgDate (layoutType, dateValue) {
      this.$emit('changeNgDateCalendar', layoutType === 'ng', dayjs([this.targetYear, this.targetMonth - 1, dateValue]))
    },
    // 子コンポーネントからemitされるメソッド. 選択された曜日を一括でok/ng切り替え
    changeNgWeek (dayOfWeekIndex) {
      const isChangedDayOfWeekTarget = this.isChangedDayOfWeeks[dayOfWeekIndex]

      // 該当する曜日の日付を変換する
      this.weeks.forEach(week => {
        const targetDate = week[dayOfWeekIndex].dateValue
        if (targetDate) {
          this.$emit('changeNgDateCalendar', isChangedDayOfWeekTarget, dayjs([this.targetYear, this.targetMonth - 1, targetDate]))
        }
      })

      // 該当する曜日の一括ng状況を反転させる
      this.$set(this.isChangedDayOfWeeks, dayOfWeekIndex, !isChangedDayOfWeekTarget)
    }
  }
}
</script>
